import { Injectable, inject } from '@angular/core';
import { FirebaseStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { FirebaseService } from '../../_firebase/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseStorageService {
  private storage: FirebaseStorage = inject(FirebaseService).storage;

  async uploadFIle(file: File, path: string): Promise<string> {
    const storageRef = ref(this.storage, path);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  }

  async deleteFile(path: string): Promise<void> {
    const storageRef = ref(this.storage, path);
    return await deleteObject(storageRef);
  }
}
